module.exports = __webpack_public_path__ + "img/logo_horizontal_black.ff2c1a11.svg";